export default __webpack_public_path__ + "static/media/TableSawImg.f695f39e.jpg";